import ResourceService from './resource.service'

class UserService extends ResourceService {
  static get resource() {
    return 'user'
  }
}

export default UserService
